<div class="mui-banner_container">
  <div class="d-flex flex-grow-1 justify-content-center">
    <i *ngIf="icon" mui-icon font="fa" [name]="icon" class="me-3 mui-banner_icon" data-testid="mui-banner-icon"></i>
    <div class="mui-banner_message" [id]="id + '-content'">
      <ng-content></ng-content>
    </div>
  </div>
  <button
    *ngIf="showDismiss"
    (click)="dismiss.emit()"
    [label]="dismissButtonLabel"
    mui-icon-btn
    appearance="ghost"
    size="small"
    icon="close"
    class="ms-3 mui-banner_close"
    data-testid="mui-banner-close"></button>
</div>
